import { template as template_f05891dded7141e9ab6fbe3a4a35aba6 } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import TrashCan from 'eflex/components/trash-can';
import QuantitySelect from 'eflex/components/quantity-select';
import { not, or, lt } from 'ember-truth-helpers';
import { fn } from '@ember/helper';
const MAX_STRINGS = 16;
export default class TaskContextConfigVision extends Component {
    @service
    store;
    @service
    intl;
    get allStringsEnabled() {
        return this.args.taskConfig.strings?.every((item)=>item.enabled);
    }
    get remainingStrings() {
        return MAX_STRINGS - this.args.task.strings.length;
    }
    addMultipleStrings = (stringQuantity)=>{
        const task = this.args.task;
        for(let i = 0; i < stringQuantity; i++){
            if (this.remainingStrings) {
                const stringCount = task.strings.length + 1;
                const name = this.intl.t('plant.task.vision.subtaskDefaultName');
                task.strings.push(this.store.createRecord('barcode-string', {
                    name: `${name} ${stringCount}`
                }));
                task.taskConfigs.forEach((config)=>{
                    config.strings.push(this.store.createRecord('barcode-string', {}));
                });
            }
        }
    };
    removeString = (index)=>{
        const task = this.args.task;
        task.taskConfigs.forEach((config)=>{
            config.strings.splice(index, 1);
        });
        task.strings.splice(index, 1);
    };
    toggleStrings = ()=>{
        this.args.taskConfig.strings.forEach((string)=>{
            string.enabled = !this.allStringsEnabled;
        });
    };
    onIsBarcodeReaderChanged = (taskString, index, checked)=>{
        taskString.isBarcodeReader = checked;
        if (!checked) {
            this.args.task.taskConfigs.forEach((config)=>{
                config.strings[index].barcodeString = '';
            });
        }
    };
    static{
        template_f05891dded7141e9ab6fbe3a4a35aba6(`
    <div class="bootstrap-table task-config-vision">
      <div class="row form-row model-specific mb-3">
        <div class="col-4">
          <@form.element
            class="program-number"
            @controlType="number"
            @label={{t "programNumber"}}
            @property="programNumber"
            @size="sm"
          />
        </div>
      </div>
      <div class="row form-row header-row">
        <div class="col-icon model-specific border-0">
          <@form.element
            @controlType="checkbox"
            @value={{this.allStringsEnabled}}
            @onChange={{this.toggleStrings}}
          />
        </div>
        <div class="col">
          {{t "task"}}
        </div>
        <div class="col-2">
          {{t "barcode"}}
        </div>
        <div class="col model-specific">
          {{t "plant.task.barcode.stringToRead"}}
        </div>
        <div class="col-icon border-0" />
      </div>

      {{#each @taskConfig.strings as |configString index|}}
        <div class="row form-row vision-string-row">
          <div class="col-icon model-specific">
            <@form.element
              @model={{configString}}
              @controlType="checkbox"
              @property="enabled"
            />
          </div>
          <div class="col vision-string-name">
            <@form.element
              @model={{configString.parentString}}
              @property="name"
              @size="sm"
            />
          </div>
          <div class="col-2 d-flex">
            <@form.element
              @model={{configString}}
              @controlType="checkbox"
              @value={{
                or
                configString.parentString.isBarcodeReader
                configString.barcodeString
              }}
              @onChange={{
                fn
                this.onIsBarcodeReaderChanged
                configString.parentString
                index
              }}
              class="is-barcode-reader"
            />
          </div>
          <div class="col model-specific">
            <@form.element
              @model={{configString}}
              @property="barcodeString"
            as |el|>
              <el.control
                class="barcode-string-to-read"
                @size="sm"
                disabled={{
                  or
                  @disabled
                  (not
                    (or
                      configString.parentString.isBarcodeReader
                      configString.barcodeString
                    )
                  )
                }}
              />
            </@form.element>
          </div>
          <div class="col-icon">
            <TrashCan
              disabled={{@disabled}}
              @onDelete={{fn this.removeString index}}
            />
          </div>
        </div>
      {{/each}}

      <div class="row mt-3">
        <div class="col-auto">
          <QuantitySelect
            class="vision-add-string"
            @disabled={{or @disabled this.addStringDisabled (lt this.remainingStrings 1)}}
            @max={{this.remainingStrings}}
            @onSubmit={{this.addMultipleStrings}}
          >
            {{t "addSubtask"}}
          </QuantitySelect>
        </div>
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
